<template>
  <div class="login text-center">
    <md-card>
      <img class="logo" src="../assets/icon.png" />

      <form @submit.prevent="login">
        <md-field>
          <label for="email">Email</label>
          <md-input name="email" type="email" id="email" v-model="email" />
        </md-field>
        <md-field>
          <label for="password">Password</label>
          <md-input
            name="password"
            type="password"
            id="password"
            v-model="password"
          />
        </md-field>
        <md-button type="submit" class="md-raised" md-theme="default-dark"
          >Log in</md-button
        >
      </form>
    </md-card>
    <p>
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      errorMessage: ""
    };
  },
  methods: {
    login: function() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            console.log(user);
            this.$router.replace("home");
          },
          err => {
            this.errorMessage = err.message;
          }
        );
    }
  }
};
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */
html,
body {
  margin: 0;
  padding: 0;
}

.login {
  top: 0;
  width: 100%;
  height: 100vh;
  background: #161934;
  background-image: linear-gradient(160deg, #2f3570 0%, #161934 100%);
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.logo {
  width: 150px;
  margin-bottom: 10px;
  border-radius: 5px;
}

form {
  width: 200px;
}
.md-card {
  padding: 40px;
}
</style>
